/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRentDto } from '../../models/backend-rent-dto';

export interface OpexesRentCopyCreate$Params {
  id: number;
}

export function opexesRentCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesRentCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRentDto>> {
  const rb = new RequestBuilder(rootUrl, opexesRentCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRentDto>;
    }),
  );
}

opexesRentCopyCreate.PATH = '/api/opexes/rent/{id}/copy/';
